import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// Product Pages - START
// // admin
import Layout from "./Layout.js";
//import Dashboard from "pages/admin/Dashboard.js";
import Home from "pages/admin/Home.js";
import User from "pages/admin/User.js";
import { Users as UsersOld } from "pages/admin/Users.js";
import Client from "pages/admin/Client.js";
import Clients from "pages/admin/Clients.js";
import ContentEditor from "pages/admin/ContentEditor.js";
import { Agents as AgentsOld } from "pages/admin/Agents";
import Agent from "pages/admin/Agent";
import MediaItem from "pages/admin/MediaItem";
import Tables from "pages/admin/Tables.js";
import WebRTC from "pages/admin/WebRTC.js";
import Workflows from "pages/admin/Workflows";
import Workflow from "pages/admin/Workflow";
import WorkflowGraph from "pages/admin/WorkflowGraph";
import WorkflowGraph2 from "pages/admin/WorkflowGraph2";
import Nodes from "pages/admin/Nodes";
import Node from "pages/admin/Node";
import Functions from "pages/admin/Functions";
import Function from "pages/admin/Function";
import SupportingContent from "pages/admin/SupportingContent";
//import SupportingContentList from "pages/admin/SupportingContentList";
import Lesson from "pages/admin/Lesson";
import Lessons from "pages/admin/Lessons";

// // auth
import Login from "pages/auth/Login.js";
import Register from "pages/auth/Register.js";
import Reset from "pages/auth/Reset.js";

import Test from "pages/Test.js";

// // e-commerce
import Checkout from "pages/e-commerce/Checkout.js";
import ECommerce from "pages/e-commerce/ECommerce.js";
import Invoice from "pages/e-commerce/Invoice.js";
import Pricing from "pages/e-commerce/Pricing.js";
import Product from "pages/e-commerce/Product.js";
import Profile1 from "pages/e-commerce/Profile1.js";
import Settings1 from "pages/e-commerce/Settings1.js";
// // error
import Error404 from "pages/error/Error404.js";
import Error500 from "pages/error/Error500.js";
// // presentation
import Landing1 from "pages/presentation/Landing1.js";
import Landing2 from "pages/presentation/Landing2.js";
import AboutUs from "pages/presentation/AboutUs.js";
import ContactUs from "pages/presentation/ContactUs.js";
import PrivateRoute from "components/PrivateRoute";

// App Pages
import ParentingTrick from "pages/apps/ParentingTrick.js";

// New Pages
import Dashboard from "pages/new/Dashboard";
import Agents from "pages/new/Agents";
import ChatSessions from "pages/new/ChatSessions";
import Responses from "pages/new/Responses";
import Media from "pages/new/Media";
import { SupportingContent as NewSupportingContent } from "pages/new/SupportingContent";
import SupportingContentItems from "pages/new/SupportingContentItems";
import Landing from "pages/new/Landing";
import Events from "pages/new/Events";
import Emails from "pages/new/Emails";
import Messages from "pages/new/Messages";
import Settings from "pages/new/Settings";
import Train from "pages/new/Train";
import Users from "pages/new/Users";
import Usage from "pages/new/Usage";
import LiveEvents from "pages/new/LiveEvents";
import LiveEventDetails from "pages/new/LiveEventDetails";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Product Pages - START */}
        {/* admin */}
        <Route
          path="/test"
          exact
          element={
            <PrivateRoute>
              <Test />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          exact
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Layout />}>
          <Route path="" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="landing" element={<Landing />} />
          <Route path="chat" element={<ChatSessions />} />
          <Route path="responses" element={<Responses />} />
          <Route path="media" element={<Media />} />
          <Route path="train" element={<Train />} />
          <Route
            path="supporting-content-items/:supportingcontent_id"
            element={<SupportingContentItems />}
          />
          <Route path="supporting-content" element={<NewSupportingContent />} />
          <Route path="settings" element={<Settings />} />
          <Route path="users" element={<Users />} />
          <Route path="webrtc" element={<WebRTC />} />
          <Route path="meet/:room_name" element={<WebRTC />} />
          <Route path="events" element={<Events />} />
          <Route path="emails" element={<Emails />} />
          <Route path="messages" element={<Messages />} />
          <Route path="agents" element={<Agents />} />
          <Route path="usage" element={<Usage />} />
          <Route path="editor/:content_id" element={<ContentEditor />} />
          <Route path="editor" element={<ContentEditor />} />
          <Route path="live-events" element={<LiveEvents />} />
          <Route path="live-event/:event_id" element={<LiveEventDetails />} />
        </Route>

        <Route path="/client/" element={<Layout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="landing" element={<Landing />} />
          <Route path="chat" element={<ChatSessions />} />
          <Route path="responses" element={<Responses />} />
          <Route path="media" element={<Media />} />
          <Route path="train" element={<Train />} />
          <Route
            path="supporting-content-items/:supportingcontent_id"
            element={<SupportingContentItems />}
          />
          <Route path="supporting-content" element={<NewSupportingContent />} />
          <Route path="settings" element={<Settings />} />
          <Route path="users" element={<Users />} />
          <Route path="webrtc" element={<WebRTC />} />
          <Route path="meet/:room_name" element={<WebRTC />} />
          <Route path="events" element={<Events />} />
          <Route path="emails" element={<Emails />} />
          <Route path="messages" element={<Messages />} />
          <Route path="agents" element={<Agents />} />
          <Route path="usage" element={<Usage />} />
          <Route path="editor/:content_id" element={<ContentEditor />} />
          <Route path="editor" element={<ContentEditor />} />
          <Route path="live-events" element={<LiveEvents />} />
          <Route path="live-event/:event_id" element={<LiveEventDetails />} />
        </Route>

        <Route
          path="/admin/user/:user_id"
          exact
          element={
            <PrivateRoute>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/user/"
          exact
          element={
            <PrivateRoute>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/webrtc/"
          exact
          element={
            <PrivateRoute>
              <WebRTC />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/meet/:room_name"
          exact
          element={
            <PrivateRoute>
              <WebRTC />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users"
          exact
          element={
            <PrivateRoute>
              <UsersOld />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/client/:client_id"
          exact
          element={
            <PrivateRoute>
              <Client />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/client/"
          exact
          element={
            <PrivateRoute>
              <Client />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/clients"
          exact
          element={
            <PrivateRoute>
              <Clients />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/agent/media/:media_id"
          element={
            <PrivateRoute>
              <MediaItem />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/supportingcontent/:supportingcontent_id"
          element={
            <PrivateRoute>
              <SupportingContent />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/supportingcontent"
          element={
            <PrivateRoute>
              <SupportingContent />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/lesson/:lessonID"
          element={
            <PrivateRoute>
              <Lesson />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/lessons/:supportingContentID"
          element={
            <PrivateRoute>
              <Lessons />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/agent/:agent_id"
          element={
            <PrivateRoute>
              <Agent />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/agent"
          element={
            <PrivateRoute>
              <Agent />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/agents"
          exact
          element={
            <PrivateRoute>
              <AgentsOld />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflow/:workflow_id"
          exact
          element={
            <PrivateRoute>
              <Workflow />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflow/:workflow_id/graph2"
          exact
          element={
            <PrivateRoute>
              <div style={{ height: "100vh", width: "100vw" }}>
                <WorkflowGraph2 />
              </div>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflow/:workflow_id/graph"
          exact
          element={
            <PrivateRoute>
              <WorkflowGraph />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflow/:workflow_id/graph/:archive_id"
          exact
          element={
            <PrivateRoute>
              <WorkflowGraph />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflow"
          exact
          element={
            <PrivateRoute>
              <Workflow />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/workflows"
          exact
          element={
            <PrivateRoute>
              <Workflows />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/node/"
          exact
          element={
            <PrivateRoute>
              <Node />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/node/:node_id"
          exact
          element={
            <PrivateRoute>
              <Node />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/nodes"
          exact
          element={
            <PrivateRoute>
              <Nodes />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/function/:function_id"
          exact
          element={
            <PrivateRoute>
              <Function />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/functions"
          exact
          element={
            <PrivateRoute>
              <Functions />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/tables"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Tables />
              </div>
            </React.Fragment>
          )}
        />
        {/* apps */}
        <Route
          path="/admin/apps/parenting-trick"
          exact
          element={<ParentingTrick />}
        />

        {/* auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" exact element={<Register />} />
        <Route
          path="/reset"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Reset />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/checkout"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Checkout />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/e-commerce"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <ECommerce />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/invoice"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Invoice />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/pricing"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Pricing />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/product"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Product />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/profile-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Profile1 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/settings-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Settings1 />
              </div>
            </React.Fragment>
          )}
        />
        {/* error */}
        <Route
          path="/error-404"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Error404 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/error-500"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Error500 />
              </div>
            </React.Fragment>
          )}
        />
        {/* presentation */}
        <Route
          path="/landing-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Landing1 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/landing-2"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Landing2 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/about-us"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <AboutUs />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/contact-us"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <ContactUs />
              </div>
            </React.Fragment>
          )}
        />
        {/* Product Pages - STOP */}
        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
